import React, { Suspense } from 'react';
import { useEditorCore } from '../hooks/useEditorCore';
import { PasswordGate } from '../components/PasswordGate';
import './pro.css';

const ProLayoutLazy = React.lazy(async () => {
  const mod = await import('./ProLayout');
  return { default: mod.ProLayout };
});

export const ProAppLite: React.FC = () => {
  const editor = useEditorCore({ basePath: '/pro' });

  return (
    <PasswordGate>
      <Suspense fallback={<div className="pro-loading-overlay"><div className="pro-loading-overlay__text">Chargement interface Pro...</div></div>}>
        <ProLayoutLazy editor={editor} />
      </Suspense>
    </PasswordGate>
  );
};

export default ProAppLite;
